import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {preservedTestAction} from "features/model/slice/test/success-test/preserved-test/preservedTestSlice";
import {getModalTests} from "features/model/slice/test/get-test/getTestSlice";
import {setBackData} from "features/model/slice/create-test/create-test-form/createTestForm";


export const fetchCreateTest = createAsyncThunk(
    'test/createTest',
    async ({ testId, requestData }: { testId: string | undefined; requestData: any }, thunkAPI) => {
        if (!testId) {
            return thunkAPI.rejectWithValue('Не удалось определить тест.');
        }

        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                return thunkAPI.rejectWithValue('No token found in localStorage.');
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.put(
                `/api/tests/${testId}`,
                requestData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.success) {
                thunkAPI.dispatch(preservedTestAction(response.data));
                thunkAPI.dispatch(setBackData(response.data.data.model));
                thunkAPI.dispatch(getModalTests(response.data.data.model));
                return response.data;
            }

            return thunkAPI.rejectWithValue(
                response.data.error || response.data.errors || 'Ошибка сохранения теста.'
            );
        } catch (error: any) {
            const message = error?.response?.data?.error
                || error?.response?.data?.errors
                || error?.message
                || 'Ошибка сохранения теста.';
            return thunkAPI.rejectWithValue(message);
        }
    }
);
